import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useOnboarding } from "./OnboardingContext";

/**
 * Route-driven advances and focus-date navigation for the teach finale.
 */
export default function OnboardingEffects() {
  const { active, stepId, completeStep, focusDate } = useOnboarding();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.replace(/\/+$/, "") || "/";

  useEffect(() => {
    if (!active || !stepId) return;
    if (stepId === "timetable-click-lesson" && path === "/scheme") {
      const params = new URLSearchParams(location.search);
      if (params.get("topic")) {
        completeStep("timetable-click-lesson");
      }
    } else if (stepId === "scheme-nav-teach" && path === "/teach") {
      completeStep("scheme-nav-teach");
    }
  }, [active, stepId, path, location.search, completeStep]);

  // When entering teach finale steps, jump to the day they scheduled.
  useEffect(() => {
    if (!active || !focusDate) return;
    if (stepId !== "teach-intro" && stepId !== "scheme-nav-teach") return;
    if (path !== "/teach") return;
    const params = new URLSearchParams(location.search);
    if (params.get("date") === focusDate) return;
    navigate(`/teach?date=${encodeURIComponent(focusDate)}`, { replace: true });
  }, [active, focusDate, stepId, path, location.search, navigate]);

  return null;
}
